var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.545,
    height: 14.729,
    viewBox: "0 0 8.545 14.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M20.478,14.153c0-2.543-2.083-2.833-3.757-3.066-1.824-.254-2.856-.474-2.856-2.045,0-1.318,1.382-1.787,2.565-1.787A3.722,3.722,0,0,1,19.5,8.7l.858-.692a4.767,4.767,0,0,0-3.184-1.805V4.5h-1.1V6.166c-1.992.121-3.307,1.246-3.307,2.877,0,2.607,2.111,2.9,3.807,3.136,1.793.25,2.807.464,2.807,1.975,0,1.671-1.727,1.921-2.756,1.921a3.755,3.755,0,0,1-3.429-1.448l-.858.692a4.65,4.65,0,0,0,3.736,1.839v1.673h1.1V17.151C19.224,16.984,20.478,15.869,20.478,14.153Z",
    transform: "translate(-12.133 -4.3)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/currency-icon.9a02ca1623a98edd0ccf7d17c0df39e1.svg";
export { ForwardRef as ReactComponent };